"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Spinner = _interopRequireDefault(require("./Spinner"));

var _LoaderModule = _interopRequireDefault(require("./Loader.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Modules
// Components
// Styles
var Loader = function Loader(props) {
  var children = props.children,
      heading = props.heading;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _LoaderModule.default.container
  }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    size: "lg"
  }), children ? children : /*#__PURE__*/_react.default.createElement("h3", {
    className: _LoaderModule.default.heading
  }, heading ? heading : 'Processing...'));
};

var _default = Loader;
exports.default = _default;